export default __webpack_public_path__ + "static/media/about-bg.e4423293.png";